import React, { Component } from 'react'

import TypeaheadComponent from '../../../typeahead'
import DateRangeComponent from '../../../datepicker'
import DateSelectorComponent from '../../../dateselector'
import MultiSelectTree from '../../../multi-select-tree'

import { FilterPositioner, FilterInput, DateRangeHolder } from './FilterBody.styles'

class FilterItemContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {}

    if (props.config.type === 'daterange') {
      this.state = {
        dateValues: {
          fromDate: (this.props.values && this.props.values.startDate) ? this.props.values.startDate : null,
          toDate: (this.props.values && this.props.values.endDate) ? this.props.values.endDate : null
        }
      }
    }
    if (props.config.type === 'datesingle') {
      this.state = {
        dateValues: (this.props.values) ? this.props.values : null
      }
    }
    if (props.config.type === 'dateselector') {
      if (this.props.values && (this.props.values.dateType === 'dateSingle' || this.props.values.dateType === 'dateRange')) {
        this.state = {
          dateValues: {
            dateType: (this.props.values && this.props.values.dateType) ? this.props.values.dateType : null,
            date: (this.props.values && this.props.values.date) ? this.props.values.date : null,
            selectedId: (this.props.values && this.props.values.selectedId) ? this.props.values.selectedId : null,
            fromDate: (this.props.values && this.props.values.startDate) ? this.props.values.startDate : null,
            toDate: (this.props.values && this.props.values.endDate) ? this.props.values.endDate : null
          }
        }
      } else {
        this.state = {
          dateValues: {
            dateType: null,
            date: null,
            fromDate: null,
            toDate: null
          }
        }
      }
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.config.type === 'daterange') {
      this.setState({
        dateValues: {
          fromDate: (newProps.values && newProps.values.startDate) ? newProps.values.startDate : null,
          toDate: (newProps.values && newProps.values.endDate) ? newProps.values.endDate : null
        }
      })
    }

    if (newProps.config.type === 'datesingle') {
      this.setState({
        dateValues: (newProps.values) ? newProps.values : null
      })
    }

    if (newProps.config.type === 'dateselector') {
      this.setState({
        dateValues: {
          dateType: (newProps.values && newProps.values.dateType) ? newProps.values.dateType : null,
          date: (newProps.values && newProps.values.date) ? newProps.values.date : null,
          selectedId: (newProps.values && newProps.values.selectedId) ? newProps.values.selectedId : null,
          fromDate: (newProps.values && newProps.values.startDate) ? newProps.values.startDate : null,
          toDate: (newProps.values && newProps.values.endDate) ? newProps.values.endDate : null
        }
      })
    }
  }

  handleSelectFilterChange = (values) => {
    const filterObject = {
      title: this.props.config.title,
      type: 'list',
      column: this.props.config.column,
      handle: this.props.handle,
      values
    }

    this.props.api.setCustomFilter(null)
    this.props.api.setCustomFilterId(null)
    this.props.api.setCustomFilterType(null)

    this.props.addAppliedFilter(filterObject)
  }

  handleMultiSelectFilterAdd = (value, multiSelectvalues, type='list') => {
    let duplcateEntry = false

    multiSelectvalues.map((item) => {
      if (item === value) {
        duplcateEntry = true
      }
    })
    if (!duplcateEntry) {
      multiSelectvalues.push(value)
      const multiSelectvaluesArray = multiSelectvalues.map((item) => {
        return {
          label: item,
          value: item
        }
      })

      const filterObject = {
        title: this.props.config.title,
        type,
        column: this.props.config.column,
        handle: this.props.handle,
        values: multiSelectvaluesArray
      }

      this.props.api.setCustomFilter(null)
      this.props.api.setCustomFilterId(null)
      this.props.api.setCustomFilterType(null)

      this.props.addAppliedFilter(filterObject)
    }
  }

  handleMultiSelectFilterRemove = (values, multiSelectvalues, type='list') => {
    const multiSelectvaluesArray = multiSelectvalues.map((item) => {
      return {
        label: item,
        value: item
      }
    })

    const filterObject = {
      title: this.props.config.title,
      type,
      column: this.props.config.column,
      handle: this.props.handle,
      values: multiSelectvaluesArray
    }

    if (multiSelectvalues.length === 0) {
      filterObject.action = 'remove'
    }

    this.props.api.setCustomFilter(null)
    this.props.api.setCustomFilterId(null)

    this.props.addAppliedFilter(filterObject)
  }

  handleTextFilterChange = (evt) => {
    const values = evt.target.value

    const filterObject = {
      title: this.props.config.title,
      type: 'search',
      column: this.props.config.column,
      handle: this.props.handle,
      values
    }

    this.props.api.setCustomFilter(null)
    this.props.api.setCustomFilterId(null)
    this.props.api.setCustomFilterType(null)

    this.props.addAppliedFilter(filterObject)
  }

  buildTextFilter() {
    return (
      <FilterInput data-testid='textFilterItem' value={this.props.values || ''} onChange={this.handleTextFilterChange} type='text' placeholder='Search...' />
    )
  }

  handleDateRangeFromDateChange = (fromDate, toDate, error) => {
    this.setState({
      dateValues: {
        fromDate,
        toDate
      }
    })
    const values = {
      startDate: fromDate,
      endDate: toDate
    }

    const filterObject = {
      title: this.props.config.title,
      type: 'daterange',
      column: this.props.config.column,
      handle: this.props.handle,
      values
    }

    if (fromDate === null && toDate === null) {
      filterObject.action = 'remove'
    }

    this.props.api.setCustomFilter(null)
    this.props.api.setCustomFilterId(null)
    this.props.api.setCustomFilterType(null)

    this.props.addAppliedFilter(filterObject)
    if (error && error.message) {
      this.props.handleInputValidationErrors(this.state.dateValues, true, this.props.handle)
    } else {
      this.props.handleInputValidationErrors(this.state.dateValues, false, this.props.handle)
    }
  }

  handleDateRangeToDateChange = (toDate, fromDate, error) => {
    this.setState({
      dateValues: {
        fromDate,
        toDate
      }
    })
    const values = {
      startDate: fromDate,
      endDate: toDate
    }

    const filterObject = {
      title: this.props.config.title,
      type: 'daterange',
      column: this.props.config.column,
      handle: this.props.handle,
      values
    }

    if (fromDate === null && toDate === null) {
      filterObject.action = 'remove'
    }

    this.props.api.setCustomFilter(null)
    this.props.api.setCustomFilterId(null)
    this.props.api.setCustomFilterType(null)

    this.props.addAppliedFilter(filterObject)

    if (error && error.message) {
      this.props.handleInputValidationErrors(this.state.dateValues, true, this.props.handle)
    } else {
      this.props.handleInputValidationErrors(this.state.dateValues, false, this.props.handle)
    }
  }

  buildDateRangeFilter() {
    let fromDate = null
    let toDate = null

    if (this.state.dateValues) {
      if (this.state.dateValues.fromDate) {
        fromDate = this.state.dateValues.fromDate
      }

      if (this.state.dateValues.toDate) {
        toDate = this.state.dateValues.toDate
      }
    }

    const config = {
      range: true,
      dateFormat: this.props.config.dateFormat || 'DD/MM/YYYY',
      fromDate,
      toDate,
      handleToDateChange: this.handleDateRangeToDateChange,
      handleFromDateChange: this.handleDateRangeFromDateChange,
      preventFutureDates: this.props.config.preventFutureDates || false,
      i18n: this.props.i18n
    }

    return (
      <DateRangeHolder data-testid='dateRangeFilterItem' >
        <DateRangeComponent {...config} />
      </DateRangeHolder>
    )
  }

  handleDateSingleChange = (date, error) => {
    if (error && error.message) {
      this.props.handleInputValidationErrors(this.state.dateValues, true, this.props.handle)
    } else {
      this.props.handleInputValidationErrors(this.state.dateValues, false, this.props.handle)
    }

    const filterObject = {
      title: this.props.config.title,
      type: 'datesingle',
      column: this.props.config.column,
      handle: this.props.handle,
      values: date
    }

    if (date === null) {
      filterObject.action = 'remove'
    }

    this.props.api.setCustomFilter(null)
    this.props.api.setCustomFilterId(null)
    this.props.api.setCustomFilterType(null)

    this.props.addAppliedFilter(filterObject)
    this.setState({
      dateValues: date
    })
  }

  buildDateSingleFilter() {
    let date = null

    if (this.state.dateValues) {
      date = this.state.dateValues
    }

    const config = {
      range: false,
      preventFutureDates: this.props.config.preventFutureDates || false,
      dateFormat: this.props.config.dateFormat || 'DD/MM/YYYY',
      date,
      handleDateChange: this.handleDateSingleChange,
      i18n: this.props.i18n
    }

    return (
      <DateRangeHolder data-testid='dateSingleFilterItem'>
        <DateRangeComponent {...config} />
      </DateRangeHolder>
    )
  }

  buildSelectFilter() {
    const options = {}

    options.values = this.props.config.values
    options.options = this.props.config.values
    options.typeAheadEnabled = this.props.config.typeAheadEnabled || false
    options.multiSelectEnabled = this.props.config.multiSelectEnabled || false
    options.maxNumOfSelections = this.props.config.maxNumOfSelections || 100
    options.controlled = true
    options.name = this.props.config.multiSelectEnabled ? 'Multiselect' : 'select'
    options.onChange = this.props.config.multiSelectEnabled ? this.handleMultiSelectFilterAdd : this.handleSelectFilterChange
    options.placeholderText = this.props.config.placeholderText || this.props.i18n.selectValue || 'Select a value'

    if (this.props.config.multiSelectEnabled && this.props.values) {
      options.selectedValues = this.props.values
    } else if (!this.props.config.multiSelectEnabled) {
      options.selectedValue = this.props.values || ''
    }

    if (this.props.config.multiSelectEnabled) {
      options.onRemove = this.handleMultiSelectFilterRemove
      options.noResultsFoundText = this.props.config.noResultsFoundText
      options.listOpenPlaceholderText = this.props.config.listOpenPlaceholderText
    }

    if (options.values === 'EXTRACT') {
      let uniqueArray = []
      let sortedUniqueArrayItems = []

      if (this.props.config.expand) {
        const arrayItems = []

        this.props.api.getUniquesFromColumn(this.props.config.column).map((item) => {
          const commaSeparatedItems = item.split(',')

          commaSeparatedItems.forEach((commaSeparateditem) => {
            arrayItems.push(commaSeparateditem.trim())
          })
        })
        uniqueArray = arrayItems.filter((arrayitem, pos) => {
          return arrayItems.indexOf(arrayitem) === pos
        })
        sortedUniqueArrayItems = uniqueArray.sort()
      } else {
        uniqueArray = this.props.api.getUniquesFromColumn(this.props.config.column).map((item) => {
          return item
        })
        sortedUniqueArrayItems = uniqueArray.sort()
      }
      options.options = sortedUniqueArrayItems.map((item) => {
        return {
          label: item,
          value: item
        }
      })
    } else if (typeof options.values === 'string' && options.values.indexOf(';') > -1) {
        const rawValues = options.values.split(';')
        const obj = []

        rawValues.map((rawItem) => {
          const rawObj = rawItem.split(',')
          const arrayObj = {
            value: rawObj[0],
            label: rawObj[1]
          }

          obj.push(arrayObj)
        })
        options.options = obj
      }

    return (
      <FilterPositioner>
        <TypeaheadComponent {...options} />
      </FilterPositioner>
    )
  }

  buildDateSelectorFilter() {
    const config = {
      name: 'Dropdown',
      multiheaderEnabled: true,
      selectedValue: this.state.dateValues.selectedId || null,
      date: this.state.dateValues.date || null,
      fromDate: this.state.dateValues.fromDate || null,
      toDate: this.state.dateValues.toDate || null,
      placeholderText: this.props.config.dateselector.i18n.header_placeholder || 'Select a new date value code',
      headers: this.props.config.dateselector.headers,
      handleDateSelector: this.handleDateSelector,
      datePicker: {
        dateFormat: this.props.config.dateselector.datePicker.dateFormat || 'DD/MM/YYYY',
        preventFutureDates: this.props.config.dateselector.datePicker.preventFutureDates || false,
        placeholder: this.props.config.dateselector.datePicker.i18n.placeholder || 'Dateplaceholder',
        fromPlaceholder: this.props.config.dateselector.datePicker.i18n.from_placeholder || 'Dateplaceholder',
        toPlaceholder: this.props.config.dateselector.datePicker.i18n.from_placeholder || 'Dateplaceholder',
        datePickerFromName: this.props.config.dateselector.datePicker.datePickerFromName || 'datePickerFromName',
        datePickerToName: this.props.config.dateselector.datePicker.datePickerToName || 'datePickerToName',
        datePickerName: this.props.config.dateselector.datePicker.datePickerName || 'datePickerName',
        locale: this.props.config.dateselector.datePicker.locale || 'en',
        dateSingleCallBack: 'dateSingleCallBack',
        dateRangeFromCallBack: 'dateRangeFromCallBack',
        dateRangeToCallBack: 'dateRangeToCallBack',
        todayLink: this.props.config.dateselector.datePicker.i18n.today_link || 'Today',
        i18n: this.props.config.dateselector.datePicker.i18n
      }
    }

    return (
      <DateRangeHolder data-testid='dateSelectorFilterItem' >
        <DateSelectorComponent {...config} />
      </DateRangeHolder>
    )
  }

  buildMultiSelectTreeFilter() {
    const onChange = values => {
      if (values.length) {
        // handleMultiSelectFilterAdd() expects a single value
        // plus a list of values that does not contain that single value
        this.handleMultiSelectFilterAdd(values.shift(), values, 'treeView')
      } else {
        this.handleMultiSelectFilterRemove(null, values, 'treeView')
      }
    }

    const values = this.props.values && this.props.values.map(entry => entry.value)

    return <MultiSelectTree
      data={this.props.config.tree}
      onChange={onChange}
      label={this.props.config.title}
      searchPlaceholder={this.props.config.placeholderText}
      searchNoResults={this.props.config.noResultsFoundText}
      values={values}
    />
  }

  handleDateSelector = (dateSelectorState) => {
    if (dateSelectorState.showSingleDatepicker) {
      this.handleDateSingleSelectorChange(dateSelectorState)
    } else if (dateSelectorState.showRangeDatepicker) {
      this.handleDateRangeSelectorChange(dateSelectorState)
    } else {
      this.props.handleInputValidationErrors(this.state.dateValues, false, this.props.handle)
      this.props.api.setCustomFilter(null)
      this.props.api.setCustomFilterId(null)
      this.props.api.setCustomFilterType(null)

      const values = {
        dateType: null,
        date: null,
        fromDate: null,
        toDate: null,
        selectedId: dateSelectorState.selectedValue
      }

      const filterObject = {
        title: this.props.config.title,
        type: 'dateselector',
        column: this.props.config.column,
        handle: this.props.handle,
        action: 'remove',
        values
      }

      this.props.addAppliedFilter(filterObject)

      this.props.handleRemoveFilter(filterObject)

      this.setState({
        dateValues: {
          dateType: null,
          date: null,
          selectedId: dateSelectorState.selectedValue,
          fromDate: null,
          toDate: null
        }
      })
    }
  }

  handleDateSingleSelectorChange = (dateSelectorState) => {
    if (dateSelectorState.error && dateSelectorState.error.message) {
      this.props.handleInputValidationErrors(this.state.dateValues, true, this.props.handle)
    } else if (dateSelectorState.date === null || dateSelectorState.date === undefined) {
      this.props.handleInputValidationErrors(this.state.dateValues, true, this.props.handle)
    } else {
      this.props.handleInputValidationErrors(this.state.dateValues, false, this.props.handle)
    }

    const values = {
      dateType: 'dateSingle',
      date: dateSelectorState.date,
      selectedId: dateSelectorState.selectedValue
    }
    const filterObject = {
      title: this.props.config.title,
      type: 'dateselector',
      column: this.props.config.column,
      handle: this.props.handle,
      values
    }

    this.props.api.setCustomFilter(null)
    this.props.api.setCustomFilterId(null)
    this.props.api.setCustomFilterType(null)

    this.props.addAppliedFilter(filterObject)
    this.setState({
      dateValues: {
        dateType: 'dateSingle',
        date: dateSelectorState.date,
        selectedId: dateSelectorState.selectedValue
      }
    })
  }

  handleDateRangeSelectorChange = (dateSelectorState) => {
    if (dateSelectorState.error && dateSelectorState.error.message) {
      this.props.handleInputValidationErrors(this.state.dateValues, true, this.props.handle)
    } else if (dateSelectorState.toDate === null || dateSelectorState.toDate === undefined ||
        dateSelectorState.fromDate === null || dateSelectorState.fromDate === undefined) {
      this.props.handleInputValidationErrors(this.state.dateValues, true, this.props.handle)
    } else {
      this.props.handleInputValidationErrors(this.state.dateValues, false, this.props.handle)
    }
    const values = {
      dateType: 'dateRange',
      startDate: dateSelectorState.fromDate,
      endDate: dateSelectorState.toDate,
      selectedId: dateSelectorState.selectedValue
    }

    const filterObject = {
      title: this.props.config.title,
      type: 'dateselector',
      column: this.props.config.column,
      handle: this.props.handle,
      values
    }

    this.props.api.setCustomFilter(null)
    this.props.api.setCustomFilterId(null)
    this.props.api.setCustomFilterType(null)

    this.props.addAppliedFilter(filterObject)
    this.setState({
      dateValues: {
        dateType: 'dateRange',
        selectedId: dateSelectorState.selectedValue,
        fromDate: dateSelectorState.fromDate,
        toDate: dateSelectorState.toDate
      }
    })
  }

  buildFilter() {
    switch (this.props.config.type) {
      case 'select':
      case 'autoselect':
        return this.buildSelectFilter()

      case 'dateselector':
        return this.buildDateSelectorFilter()

      case 'daterange':
        return this.buildDateRangeFilter()

      case 'datesingle':
        return this.buildDateSingleFilter()

      case 'text':
        return this.buildTextFilter()

      case 'treeView':
        return this.buildMultiSelectTreeFilter()

      default:
        console.log('FilterItem.buildFilters() unknown:', this.props.config.type)
    }
  }

  render() {
    return (
      <div>{this.buildFilter()}</div>
    )
  };
}

export default FilterItemContainer
